var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="custom_empty"> <div class="content-wrapper" data-help="custom"> <div class="row"> <div class="col-sm-9"> <div class="row"> <div class="col-sm-12 pr-0"> <h3 class="text-dark font-weight-bold mb-0 mr-5">'+
((__t=( resources['X200415'] ))==null?'':__t)+
'</h3> </div> </div> </div> </div> <div class="row mt-3"> <div class="col-12 grid-margin stretch-card"> <div class="card"> <div class="card-body"> <div id="customInformation" class="e4usInformation" style="display:none"></div> <h4 class="card-title">'+
((__t=( resources['X200415'] ))==null?'':__t)+
'</h4> <form class="forms-sample"> <div class="d-sm-flex justify-content-center justify-content-sm-between"> <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">'+
((__t=( resources['X200416'] ))==null?'':__t)+
'<a id="customSubscriptionStripe_a" href="" target="_blank">'+
((__t=( resources['X200417'] ))==null?'':__t)+
'</a></span> </div> </form> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
